module.exports = __webpack_public_path__ + "static/media/AlbertSans-VariableFont_wght.fdc19892.ttf";